import { EncryptService } from "../app/services/encrypt.service";
import { Constant } from "../constants/constant";

export const environment = {
    production: false,
    serverAPI: 'https://www.calsoftgroup.com/ecom-gateway/ecom-svc-catalog-1.0-SNAPSHOT',
    serverAPI2: 'https://www.calsoftgroup.com/ecom-gateway/ecom-svc-core-1.0-SNAPSHOT',
    serverAPI3: 'https://www.calsoftgroup.com/ecom-gateway/ecom-svc-sales-1.0-SNAPSHOT',
    serverAPI4: 'https://www.calsoftgroup.com/ecom-gateway/ecom-svc-admin-1.0-SNAPSHOT',
    serverAPI6: 'https://www.calsoftgroup.com/ecom-gateway/ecom-svc-partner-1.0-SNAPSHOT',
    serverAPI7: 'https://www.calsoftgroup.com/ecom-gateway/ecom-svc-deploy-1.0-SNAPSHOT',
    ImageAPI: 'https://www.calsoftgroup.com/ecom-gateway/ecom-svc-core-1.0-SNAPSHOT/api/core/download?fileName=catalog/product/small_image/200x170/',
    ImageAPI1: 'https://www.calsoftgroup.com/ecom-gateway/ecom-svc-core-1.0-SNAPSHOT/api/core/download?fileName=catalog/product/image/600x600/',
    ImagePartnerAPI: 'https://www.calsoftgroup.com/ecom-gateway/ecom-svc-core-1.0-SNAPSHOT/api/core/download/partner?fileName=',
    commonImageApi: 'https://www.calsoftgroup.com/ecom-gateway/ecom-svc-core-1.0-SNAPSHOT/api/core/download?fileName=',
    youtubeUrl: 'https://www.youtube.com/embed/',
    thumnail: 'https://www.calsoftgroup.com/ecom-gateway/ecom-svc-core-1.0-SNAPSHOT/api/core/download?fileName=catalog/product/thumbnail/75x75/',
    commonImageApiNew: 'https://www.calsoftgroup.com/ecom-gateway/ecom-svc-core-1.0-SNAPSHOT/api/core/download/common?fileName=',
    HostUrl:'https://www.calsoftgroup.com',
    videoSocketUrl:'https://www.calsoftgroup.com/ecom-gateway1/api',   
    firebase: getConfig(),
  };

  function getConfig(this: any) {
    let config;
    let finalData = localStorage.getItem("m-d");
    let encryptService = new EncryptService();
    let obj = null;
    if (finalData != null) {
  
      try {
        obj = JSON.parse(encryptService.decryptionAES(finalData));
      } catch (error) {
        obj = null;
      }
    }
    if (obj != null) {
  
      config = {
        apiKey: obj['apiKey'],
        authDomain: obj['authDomain'],
        projectId: obj['projectId'],
        storageBucket: obj['storageBucket'],
        messagingSenderId: obj['messagingSenderId'],
        appId: obj['appId']
      };
  
    } else {
  
  
      let request = new XMLHttpRequest();
      try {
  
  
        var url = "https://" + Constant.REFERER + '/ecom-gateway/ecom-svc-catalog-1.0-SNAPSHOT/api/catalog/siteData'
        //var url = 'http://localhost:8086/ecom-gateway/ecom-svc-catalog-1.0-SNAPSHOT' + "/api/catalog/siteData"
  
        request.open('GET', url, false);  // `false` makes the request synchronous
        request.setRequestHeader('Content-Type', 'application/json');
  
        request.setRequestHeader(Constant.DEVICE, Constant.DEVICE_TYPE);
  
        request.setRequestHeader(Constant.ENTERPRISE_SITE, Constant.REFERER);
  
  
        request.send(null);
  
        // console.log(request);
  
        if (request.status === 200) {
          //  console.log(request.responseText);
          config = request.responseText;
          obj = JSON.parse(request.responseText);
          let valueNew = this.ecryptService.encryptionAES(JSON.stringify(obj));
  
          localStorage.setItem("m-d", valueNew);
          config = {
            apiKey: obj['apiKey'],
            authDomain: obj['authDomain'],
            projectId: obj['projectId'],
            storageBucket: obj['storageBucket'],
            messagingSenderId: obj['messagingSenderId'],
            appId: obj['appId']
          };
        }
  
      } catch (e) {
        console.error('environment:getConfig: unable to get api key : ', e);
      }
  
    }
  
  
    return config;
  }